import React from 'react';
import _ from 'lodash';
import styled from 'styled-components';
import { Dropdown } from 'react-dropdown-now';
import 'react-dropdown-now/style.css';

function DropDownField({
  options = [],
  value = '',
  selectAction = _.noop,
  defaultItem = '',
  placeholder = 'Selecioná una opción',
}) {
  const handleSelection = (value) => {
    selectAction(value);
  };

  const StyledSelect = styled(Dropdown)`
    border-radius: 10px;
  `;

  return (
    <StyledSelect
      placeholder={placeholder}
      className="my-className"
      options={options}
      value={value}
      onChange={(value) => handleSelection(value)}
    />
  );
}

export default DropDownField;
